<template>
  <div>
    <el-dialog
      :visible.sync="showSaveVisible"
      :close-on-click-modal="false"
      width="30%">
      <span>是否保存更新？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSaveVisible = false" type="info" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="save('ruleForm')" :loading="sureLoading">确 定</el-button>
      </span>
    </el-dialog>

    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder;float: left">{{ $route.query.flag === 'update' ? '更新机构' : '查看机构' }}</span>
        </div>
        <div class="text item">
          <el-form
            label-position="top"
            :model="dept"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm">
            <el-row>
              <el-col :span="colSpan" :offset="colSpanOffSet">
                <el-form-item label="机构名称" :size="inputFromSize" prop="name">
                  <el-input :class="$route.query.flag === 'update' ? '' : 'text-input'" v-model="dept.name"
                            :disabled="$route.query.flag !== 'update'" placeholder="请输入机构名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="colSpan" :offset="colSpanOffSet+1">
                <!--模拟设置数据回显:placeholder="dept.parentName" -->
                <el-form-item label="上级机构" :size="inputFromSize" prop="parentIds">
                  <yl-cascader
                    class="text-input"
                    :disabled="$route.query.flag !== 'update'"
                    ref="deptCascader"
                    style="display: block"
                    :checkStrictly="true"
                    v-model="dept.parentIds"
                    :placeholder="dept.parentName"
                    :show-all-levels="false"
                    :props="{ checkStrictly: true }"
                    :options="deptData"
                    @change="handleChange"
                    clearable
                    filterable>
                  </yl-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="colSpan" :offset="colSpanOffSet">

                <el-form-item label="创建人" :size="inputFromSize">
                  <el-input class="text-input" disabled v-model="dept.createUserName"></el-input>
                </el-form-item>

              </el-col>

              <el-col :span="colSpan" :offset="colSpanOffSet+1">
                <el-form-item label="创建时间" :size="inputFromSize">
                  <el-input class="text-input" disabled v-model="dept.createTm"></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="colSpan" :offset="colSpanOffSet">

                <el-form-item label="最后修改人" :size="inputFromSize">
                  <el-input class="text-input" disabled v-model="dept.lastModUserName"></el-input>
                </el-form-item>

              </el-col>

              <el-col :span="colSpan" :offset="colSpanOffSet+1">
                <el-form-item label="最后修改时间" :size="inputFromSize">
                  <el-input class="text-input" disabled v-model="dept.lastModTm"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22" :offset="1">
                <el-form-item label="机构描述">
                  <el-input class="text-input" :disabled="$route.query.flag !== 'update'" type="textarea"
                            maxlength="500" rows="6" show-word-limit v-model="dept.intro"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-form>
          <!--style="float: right; padding: 3px 0"往右浮动-->
          <el-form-item>
            <div style="text-align: center">
              <common-button type="cancel" image @click="goBack">返回</common-button>
              <common-button type="primary" image @click="triggerChecked('ruleForm')"
                         v-show="deptPower && $route.query.flag === 'update'"
                         :loading="sureLoading">
                保存
              </common-button>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <div>
      <!--科室信息-->
<!--      <SectionInfo v-show="showSectionLv.includes(dept.tp)" ref="section"/>-->
    </div>

    <!--加载动画-->
    <animation :loadingDataVisible="loadingDataVisible"></animation>

  </div>
</template>

<script>
import 'animate.css';
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
import {mapState} from 'vuex';
import SectionInfo from '@/components/section/SectionInfo'
//引入formatDatetime方法
import {formatDatetime} from '@/utils/dateUtil'
import animation from '@/components/loading/animation'
//获取机构的级联控制器的回显数据
import {getCascaderFullValue} from '@/utils/cascader'

export default {
  name: "Update",
  data() {
    return {
      loadingDataVisible: false,
      //设置等级为5的才显示科室
      showSectionLv: ['5'],
      deptPower: false,
      superPower: false,
      //保存提示框是否可见
      showSaveVisible: false,
      colSpanOffSet: 1,
      colSpan: 10,
      sureLoading: false,
      inputFromSize: "small",
      dept: {
        id: "",
        name: "",
        createUserName: "",
        lastModUserName: "",
        intro: "",
        tp: "",
        parentName: "",
        parentIds: [],
        flag: 'view',
      },
      rules: {
        name: [
          {required: true, message: '请输入机构名称', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 32 个字符之内', trigger: 'blur'}
        ],
        parent: [
          {required: true, message: '请输入上级机构', trigger: 'blur'}
        ],
      },
      deptData: []
    }
  },

  components: {
    SectionInfo,
    animation,
  },

  mounted() {
    //获取用户的操作权限
    this.getAuth()
    this.loadingDataVisible = true
    this.dept.id = this.$route.query.deptId
    this.dept.flag = this.$route.query.flag
    // this.$refs.section.getSectionOptPower(this.dept.flag)
    //设置页面的加载数据中
    if (!this.dept.id) {
      this.goHome()
    } else {
      this.initPageData();
    }

    //如果是更新操作 添加重新刷新提示
    if (this.dept.flag === 'update') {
      window.onbeforeunload = () => {
        // 此处调用保存的方法
        return 'tips'
      }
    }
  },

  watch: {
    userPower() {
      this.deptPower = this.$store.state.userPowerStore.deptPower
      this.superPower = this.$store.state.userPowerStore.superPower
    },
    treeDeptData(newVal) {
      this.deptData = newVal
      //回显数据
      this.dept.parentIds = getCascaderFullValue(this.deptData, this.dept.parentId);
    },

    //显示机构的基本信息
    department(newVal) {
      this.dept = newVal
      if (this.showSectionLv.includes(this.dept.tp)) {
        //路由直接调用方法显示列表数据
        // this.$refs.section.sectionList(this.dept.id)
      }

      //获取该用户所有机构的tree格式的数据
      this.$store.dispatch("loadingTreeDeptData")

    }

  },

  computed: mapState({
    userPower: state => state.userPowerStore.userPower,
    treeDeptData: state => state.departmentStore.treeDeptData,
    department: state => state.departmentStore.department,
  }),

  destroyed() {
    //清除浏览器刷新弹窗
    window.onbeforeunload = null
  },

  methods: {

    //初始化页面的数据
    initPageData() {
      //查询机构的基本信息
      this.$store.dispatch("findById", this.dept.id).finally(() => {
        this.loadingDataVisible = false
      })
    },

    triggerChecked(formName) {
      let flag = false;
      //validate触发检验
      this.$refs[formName].validate((valid) => {
        flag = valid;
      });
      if (!flag) {
        return
      }
      this.showSaveVisible = true
    },

    handleChange(value) {
      this.$refs.deptCascader.dropDownVisible = false
      if (value) {
        this.dept.parentId = value[value.length - 1]
      }
    },

    goHome() {
      this.$router.push({
        path: "/home",
      })
    },

    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        this.deptPower = this.$store.state.userPowerStore.deptPower
        this.superPower = this.$store.state.userPowerStore.superPower
      })
    },


    //保存修改机构的信息
    save() {
      this.sureLoading = true;
      let obj = {
        token: cookie.getCookie('token'),
        data: {
          id: this.dept.id,
          name: this.dept.name,
          parentId: this.dept.parentId ? this.dept.parentId : null,
          intro: this.dept.intro
        }
      }

      http.post(window.config.api.baseUrl + '/eims-api/department/update', obj).then(value => {
        if (value.data.code === '00000') {
          Message.success({message: "机构信息修改成功", showClose: true})
          //获取该用户所有机构的tree格式的数据
          this.$store.dispatch("loadingTreeDeptData")
          //获取选当前选中的上级机构的名字 并赋值回到 placeholder中
          let dept = value.data.data.department
          dept.createTm = formatDatetime(dept.createTm, 'yyyy-MM-dd \n hh:mm:ss')
          dept.lastModTm = formatDatetime(dept.lastModTm, 'yyyy-MM-dd \n hh:mm:ss')
          this.dept = dept
          this.updateCacheData(dept);
        }
      }).finally(() => {
        this.sureLoading = false;
        this.showSaveVisible = false;
      })
    },

    //更新缓存的数据
    updateCacheData(department) {
      let deptData = this.$store.state.departmentStore.deptListData
      for (let i = 0; i < deptData.length; i++) {
        if (department.id === deptData[i].id) {
          deptData[i] = department
        }
      }
    },

    //返回上一页
    goBack() {
      this.$router.back()
    },

  }
}
</script>


<style scoped>

.text {
  font-size: 14px;
}

.item {
  text-align: left;
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 100%;
  border-radius: 10px
}

/deep/ .el-input.is-disabled .el-input__inner {
  border-radius: 0px;
  background-color: transparent;
  border: 0px;
  color: #606266;
  cursor: text;
  padding: 0px
}

/deep/ .el-cascader .el-input.is-disabled .el-icon-arrow-down:before {
  content: '';
}

/*修改被禁用的placeholder文字颜色*/
/deep/ .el-input.is-disabled ::placeholder {
  color: #606266 !important;
}

</style>




// WEBPACK FOOTER //
// src/pages/dept/Update.vue